import React from 'react';
import { FDPrimaryActionButton, FDStack, FDDialogContent } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import MetaLayoutFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutFields';

import { DialogActions, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { useFormActions } from './useFormActions';

export const Layout = () => {
  const { resource } = useMetaLayoutContext();

  const {
    showActions,
    showSubmitButton,
    showDeleteButton,
    handleSubmit,
    handleDelete,
    onDeleteSuccess,
    submitting,
  } = useFormActions(resource);
  return (
    <>
      <DialogTitle value={`${(resource.id() !== undefined) ? 'Edit' : 'Create'} ${resource.type()}`} />
      <FDDialogContent>
        <FDStack spacing={2} direction="column" alignItems="center">
          <MetaLayoutFields
            resource={resource}
          />
          {showDeleteButton ? (
            <WizardStepDeleteButton
              onDelete={handleDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: 'Removing this item will delete all of its information. This cannot be undone.',
                cancelLabel: 'Nevermind',
                confirmLabel: 'Remove',
              }}
            />
          ) : null}
          {showActions ? (
            <DialogActions>
              {showSubmitButton ? (
                <FDPrimaryActionButton
                  label="Submit"
                  onClick={handleSubmit}
                  isFullWidth
                  size="lg"
                  loading={submitting}
                  disabled={submitting}
                />
              ) : null}
            </DialogActions>
          ) : null}
        </FDStack>
      </FDDialogContent>
    </>
  );
};
